/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class Caixa {
  constructor () {
    this.caixa_id = uuidV4()
    this.descr = ''
  }
}
